import React from 'react';

export const Skeleton = ({ className = '', label }) => (
  <span
    className={`block animate-pulse rounded-ds-sm bg-gray-200 ${className}`.trim()}
    aria-busy="true"
    role={label ? 'status' : undefined}
    aria-hidden={label ? undefined : true}
  >{label && <span className="sr-only">{label}</span>}</span>
);

export const SkeletonRow = ({ className = '' }) => (
  <div className={`flex items-center gap-ds-3 py-ds-3 ${className}`.trim()}>
    <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
    <div className="min-w-0 flex-1 space-y-ds-2">
      <Skeleton className="h-3 w-full max-w-[14rem]" />
      <Skeleton className="h-3 max-w-[10rem] w-2/3" />
    </div>
  </div>
);

export const SkeletonCard = ({ className = '' }) => (
  <div className={`rounded-ds-lg border border-gray-200 p-ds-6 ${className}`.trim()}>
    <Skeleton className="mb-ds-4 h-5 w-1/3" />
    <Skeleton className="mb-ds-2 h-3 w-full" />
    <Skeleton className="h-3 w-5/6" />
  </div>
);

export const SkeletonTable = ({ rows = 4, className = '' }) => (
  <div className={`rounded-ds-lg border border-gray-200 p-ds-4 ${className}`.trim()}>
    <Skeleton className="mb-ds-4 h-6 w-full" />
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonRow key={i} className={i === rows - 1 ? '!pb-0' : ''} />
    ))}
  </div>
);

export default Skeleton;
